import { OpenPanel } from '@openpanel/web';

const debug = false;

let isLocalhost =
  window.origin.includes('localhost') || window.origin.includes('gitpod');

if (debug) {
  isLocalhost = false;
}

let op = null;

if (!isLocalhost && process.env.OPENPANEL_CLIENT_ID) {
  op = new OpenPanel({
    clientId: process.env.OPENPANEL_CLIENT_ID,
    apiUrl: `${process.env.OPENPANEL_HOST}/api`,
    trackScreenViews: false,
    trackOutgoingLinks: true,
    trackAttributes: true,
  });
}

export { op, debug, isLocalhost };
